import { render, staticRenderFns } from "./EmployeeSearchWidget.vue?vue&type=template&id=12a9e050"
import script from "./EmployeeSearchWidget.vue?vue&type=script&lang=js"
export * from "./EmployeeSearchWidget.vue?vue&type=script&lang=js"
import style0 from "./EmployeeSearchWidget.vue?vue&type=style&index=0&id=12a9e050&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports